import React, { useMemo, useState } from 'react'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import SimpleDialog from 'components_new/molecules/SimpleDialog'

import InvalidMetrics from '../InvalidMetrics'

import { useMetrics } from 'redux/hooks/Metrics'
import { useTranslation } from 'language/translator'
import AdminList from 'components_new/organisms/AdminList'
import { getTheme } from 'themes'
import { ThemeProvider } from '@mui/material'

interface NoDataProps {
  embedded: boolean
  metrics: string[]
  scaleFactor: number
}

const NoData = (props: NoDataProps) => {
  const { embedded, metrics, scaleFactor } = props

  const { t, lang } = useTranslation()

  const [allMetrics] = useMetrics()
  const [dialogOpen, setDialogOpen] = useState(false)

  const missingMetrics = useMemo(() => {
    if (embedded) {
      return []
    }

    return metrics.map((id) => {
      const exists = allMetrics.find((item) => item.id === id)

      return {
        id,
        title: exists?.title[lang] || t('metrics', 'metric')
      }
    })
  }, [metrics, allMetrics])

  if (embedded) {
    return (
      <EmptyPlaceholder
        background={true}
        scaleFactor={scaleFactor}
        title={t('widgets', 'widget_missing_data_error')}
        icon="InboxTwoTone"
      />
    )
  }

  return (
    <>
      <EmptyPlaceholder
        actions={
          <Button onClick={() => setDialogOpen(true)}>
            {t('widgets', 'request_data')}
          </Button>
        }
        background={true}
        scaleFactor={scaleFactor}
        title={
          <>
            {t('widgets', 'widget_missing_data_error')}
            <InvalidMetrics metrics={missingMetrics} />
          </>
        }
        icon="InboxTwoTone"
      />
      <ThemeProvider theme={getTheme('light')}>
        <SimpleDialog
          onClose={() => setDialogOpen(false)}
          open={dialogOpen}
          title={t('widgets', 'request_data')}
          actions={
            <Button onClick={() => setDialogOpen(false)} variant="text">
              {t('global', 'close')}
            </Button>
          }
        >
          <EmptyPlaceholder
            background={true}
            title={t('widgets', 'widget_missing_data_error')}
            icon="InboxTwoTone"
            sx={{ mb: 4 }}
          />
          <Text align="center" variant="subtitle1" sx={{ my: 2 }}>
            {t('widgets', 'recommend_contact')}
          </Text>
          <Box
            sx={{
              maxWidth: 'content'
            }}
          >
            <AdminList />
          </Box>
          <Text align="center" variant="subtitle1" sx={{ my: 2 }}>
            {t('widgets', 'to_enable_data')}
          </Text>
        </SimpleDialog>
      </ThemeProvider>
    </>
  )
}

export default NoData
